import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { PROVIDER_LIST_FORM_KEY, PROVIDER_LIST_STORAGE_KEY } from '../provider_const';
import { ProviderPageState, ProviderDataItem, AdminProviderSearchModel } from './provider_list_types';
import { providerPageStateVM, providerSearchStateVM } from './provider_list_view_models';

// PAGE
export const providerPageStateAtom = atom<ProviderPageState>(providerPageStateVM());

// SEARCH
export const providerSearchFormAtom = atom<AdminProviderSearchModel>(providerSearchStateVM());

// TABLE
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const providerDataAtom = atom<TableDataState<ProviderDataItem>>(tableDataVM<ProviderDataItem>());

// Provider Usage Tab atoms
export const tableUsageStateAtom = atom<TableState>({
    init: false,
    waiting: false,
    views: [],
    currentViewId: '',
});
export const tableUsageViewAtom = atom<TblView>(tableViewVM());
export const tableUsageStatsAtom = atom<TblStats>(tableStatsVM());

// VIEWSTATE: TABLE
export function setAtomProviderListTableViewState(atomsDestroyed: boolean = false): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    console.log('setAtomProviderListTableViewState: saving viewstate, atomsDestroyed=', atomsDestroyed);

    // don't save empty viewstate if atoms are destroyed
    if (atomsDestroyed) {
        return;
    }

    // save table viewstate
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);

    tableViewRepo.setTable(PROVIDER_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}

// VIEWSTATE: FORM
export function setAtomProviderFormState(atomsDestroyed: boolean = false): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)

    // don't save empty viewstate if atoms are destroyed
    if (atomsDestroyed) {
        return;
    }

    // save query form state
    const defaultStore = getDefaultStore();
    const formState = defaultStore.get<AdminProviderSearchModel>(providerSearchFormAtom);
    tableViewRepo.setForm(PROVIDER_LIST_FORM_KEY, formState);
}
